module.exports = "/static/media/dot-texture.6d1a91f0.svg";